/* eslint-disable global-require */
// imports aren't the most efficient here

export default [
  {
    name: "Helpful Engineering",
    logo: require("./helpful.png"),
    link: "https://www.helpfulengineering.org/",
  },
  {
    name: "Harvard’s Coronavirus Visualization Team",
    logo: require("./harvard.png"),
    link: "https://scholar.harvard.edu/cvt/erevna",
  },
  {
    name: "The Programming Foundation",
    logo: require("./tpf.svg"),
    link: "https://www.theprogrammingfoundation.org/",
  },
  {
    name: "Mutual Aid Hub",
    logo: require("./mutual-aid-hub.png"),
    link: "https://www.mutualaidhub.org/",
  },
  {
    name: "Mutual Aid.Wiki",
    logo: require("./mutual-aid-wiki.png"),
    link: "https://mutualaid.wiki/",
  },
  {
    name: "Town Hall Project",
    logo: require("./town-hall-project.png"),
    link: "https://townhallproject.com/",
  },
  {
    name: "Mutual Aid.World",
    logo: require("./mutual-aid-world.png"),
    link: "https://mutualaid.world/",
  },
  {
    name: "PCR Testing",
    logo: require("./pcr-testing.png"),
    link: "https://www.pcrtesting.com/",
  },
  {
    name: "AIESEC",
    logo: require("./aiesec.png"),
    link: "http://aiesec.pt/",
  },
  {
    name: "House of Good Deeds",
    logo: require("./hogd.png"),
    link: "https://houseofgooddeeds.org/",
  },
]
